import React from 'react';
import LocationTemplate from './LocationTemplate';

const HatterasPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Hatteras"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27943"]}
      latitude={35.2251}
      longitude={-75.6946}
      population={504}
      historicalFact="Located on Hatteras Island, home to Cape Hatteras Lighthouse, tallest brick lighthouse in North America."
      nearbyTowns={[
        "Ocracoke, NC",
        "Frisco, NC",
        "Buxton, NC",
        "Avon, NC",
        "Salvo, NC",
        "Rodanthe, NC",
        "Waves, NC",
        "Cedar Island, NC"
      ]}
    />
  );
};

export default HatterasPage;